import React, { CSSProperties, useEffect, useState } from 'react';

import { Select, SelectProps } from 'antd';
import { BaseEnum, MappedEnum, getMappedEnum, EnumOptions } from './EnumUtils';

interface Props extends SelectProps<number | string> {
    enumType: BaseEnum,
    enumOptions?: EnumOptions,
    width?: number,
    readOnly?: boolean
}

const EnumSelect: React.FC<Props> = ({
    enumType,
    enumOptions,
    width,
    readOnly,  
    ...rest
}) => {

    const [options, setOptions] = useState<MappedEnum>([]);

    useEffect(() => {
        setOptions(getMappedEnum(enumType, enumOptions))
    }, [enumType, enumOptions])

    const style: CSSProperties = {
        width: width ?? "auto",
        whiteSpace: "nowrap",
        ...rest.style
    }

    return <Select<number | string> style={style} disabled={readOnly} options={options} {...rest} />    
}

export default EnumSelect;